export const NGX_SEO_TITLE_KEYS = {
    ogTitle: 'og:title',
    twitterTitle: 'twitter:title',
    name: 'name',
  };